import { FC } from "react"

import { PageTemplate } from "../../components/pageTemplate/PageTemplate"
import acl from "../../img/coordinatorLogos/ACL_txt_colour.png"
import ac from "../../img/coordinatorLogos/aeronautica_civil.svg"
import acd from "../../img/coordinatorLogos/ACD.jpeg"
import acn from "../../img/coordinatorLogos/ACN.jpeg"
import acs from "../../img/coordinatorLogos/ACS.gif"
import adm from "../../img/coordinatorLogos/ADM.png"
import aecfa from "../../img/coordinatorLogos/AECFA.png"
import anac from "../../img/coordinatorLogos/ANAC.png"
import asa from "../../img/coordinatorLogos/ASA.png"
import bh from "../../img/coordinatorLogos/BH.jpeg"
import bsc from "../../img/coordinatorLogos/BSC.png"
import cad from "../../img/coordinatorLogos/CAD.png"
import cyp from "../../img/coordinatorLogos/CYP.png"
import fraportBrasil from "../../img/coordinatorLogos/fraport_brasil.png"
import tp from "../../img/coordinatorLogos/TP.svg"
import hsca from "../../img/coordinatorLogos/HSCA.png"
import IAA from "../../img/coordinatorLogos/IAA_logo.gif"
import IA from "../../img/coordinatorLogos/IA.png"
import nav from "../../img/coordinatorLogos/NAV.png"
import pansa from "../../img/coordinatorLogos/PANSA.png"
import sba from "../../img/coordinatorLogos/SBA.png"
import sca from "../../img/coordinatorLogos/SCA.png"
import sccr from "../../img/coordinatorLogos/SCCR.png"
import scs from "../../img/coordinatorLogos/SCS.svg"

export const About: FC = () => {
  // const versionInfo = useAppSelector((state) => state["appReducer"].version)

  // //This is just for test purpose
  // const a: any = document.querySelectorAll("script")
  // let f = [...a]
  // const c = f.map((a) => {
  //   const outerHtml = a.outerHTML
  //   return outerHtml
  // })

  return (
    <PageTemplate
      pageTitle="About OCS"
      pageContentClassName="info-page-container"
    >
      <article className="d-flex align-items-center flex-column">
        <section className="info-page-txt">
          <header>About OCS</header>
          <p>
            The Online Coordination System (OCS) is a powerful system that
            allows users to access coordinators’ databases for airports around
            the world. OCS provides real-time airport slot availability
            displays, and OCS users can view and download the latest schedule
            information. Authorised users can make online requests to add,
            change and delete slots and get immediate responses, including
            automatic offers and the ability to coordinate slots at multiple
            airports at the same time.
          </p>
          <p>
            OCS was developed by Prolog Development Center (PDC) for Airport
            Coordination Limited (ACL) and went live in 2003. The vision was for
            OCS to enable airlines and other users to access multiple
            coordinator databases from a central portal, allowing them to
            coordinate slots at many airports in a convenient and secure way.
            Other coordinators quickly joined, and now there are about 120
            airports from more than 20 countries around the world available and
            accessible on OCS.
          </p>
          <p>
            In 2011 the coordinators using OCS formed the OCS Portal Group as a
            forum to manage the OCS Portal and initiate developments of the
            website. The OCS Portal Group has a Technical Working Group to
            initiate developments, and the TWG holds regular User Group meetings
            to solicit ideas from the customers on how to make OCS better.
          </p>
          <p>
            If you have any suggestions or ideas, please contact us at{" "}
            <a href="mailto:help@online-coordination.com">
              help@online-coordination.com
            </a>
            .
          </p>
        </section>
        <section className="w-100p about-coordinators d-flex flex-column align-items-center">
          <header>OCS is used by coordinators from all around the world</header>
          <div className="coordinators-logo-container d-flex flex-wrap">
            <div>
              <a
                href="https://www.aerocivil.gov.co/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={ac} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://airportcoordination.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={acd} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://www.acl-uk.org/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={acl} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://airportcoordination.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={acn} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://airportcoordination.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={acs} alt="" />
              </a>
            </div>
            <div>
              <a href="https://www.admtl.com/" target="_blank" rel="noreferrer">
                <img src={adm} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://www.slotcoordination.es/es/slot/inicio"
                target="_blank"
                rel="noreferrer"
              >
                <img src={aecfa} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://www.gov.br/anac/pt-br"
                target="_blank"
                rel="noreferrer"
              >
                <img src={anac} alt="" />
              </a>
            </div>
            <div>
              <a href="https://www.asa.cv/" target="_blank" rel="noreferrer">
                <img src={asa} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://www.bh-airport.com.br/SitePages/pt/Home.aspx"
                target="_blank"
                rel="noreferrer"
              >
                <img src={bh} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://www.brucoord.org"
                target="_blank"
                rel="noreferrer"
              >
                <img src={bsc} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://www.hkgslot.gov.hk/Home.html"
                target="_blank"
                rel="noreferrer"
              >
                <img src={cad} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://www.slots-cyprus.eu/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={cyp} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://www.fraport.com/en/our-group/our-airports-and-subsidiaries/Fraport-Brasil-SA-Aeroporto-de-Fortaleza.html"
                target="_blank"
                rel="noreferrer"
              >
                <img src={fraportBrasil} alt="" />
              </a>
            </div>
            <div>
              <a href="http://www.hsca.gr/" target="_blank" rel="noreferrer">
                <img src={hsca} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://www.iaa.gov.il/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={IAA} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://www4.infraero.gov.br/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={IA} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://slots.nav.pt/en/slot-coordination-portugal"
                target="_blank"
                rel="noreferrer"
              >
                <img src={nav} alt="" />
              </a>
            </div>
            <div>
              <a href="https://www.pansa.pl/" target="_blank" rel="noreferrer">
                <img src={pansa} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://www.salvador-airport.com.br/pt-br"
                target="_blank"
                rel="noreferrer"
              >
                <img src={sba} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://www.slots-austria.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={sca} alt="" />
              </a>
            </div>
            <div>
              <a
                href="http://www.slot-czech.cz/en/site/about.htm"
                target="_blank"
                rel="noreferrer"
              >
                <img src={sccr} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://www.slotcoordination.ch/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={scs} alt="" />
              </a>
            </div>
            <div>
              <a
                href="https://www.torontopearson.com/en/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={tp} alt="" />
              </a>
            </div>
          </div>
        </section>
      </article>
    </PageTemplate>
  )
}
